import { FormattedMessage } from "react-intl";
import { Box, Group, Text } from "@mantine/core";

import { formatSek } from "../../utils/formatPension";
import { REPLAY_BLOCK_CLASS } from "../../utils/statsig";
import { SECONDARY_TEXT_COLOR } from "../../constants/colors";
import type { FundSwitchPartsProps } from "../../types";
import classes from "./index.module.css";

export function FundSwitchParts({
  fundPartValue,
  traditionalValue,
}: FundSwitchPartsProps) {
  return (
    <Box className={`${classes.parts} ${classes.indented}`}>
      <Group justify="space-between" align="flex-start" wrap="nowrap" gap="md">
        <Text size="sm" fw={700}>
          <FormattedMessage
            id="insurance.fundSwitch.available.title"
            defaultMessage="Tillgängligt för fondbyte"
          />
        </Text>
        <Text size="sm" fw={700} className={REPLAY_BLOCK_CLASS}>
          {formatSek(fundPartValue)}
        </Text>
      </Group>
      <Text size="sm" c={SECONDARY_TEXT_COLOR} mt={4}>
        <span className={REPLAY_BLOCK_CLASS}>
          {formatSek(traditionalValue)}
        </span>{" "}
        <FormattedMessage
          id="insurance.fundSwitch.traditional.description"
          defaultMessage="i traditionell förvaltning kan inte bytas eller flyttas."
        />
      </Text>
    </Box>
  );
}
